// @ts-nocheck
// TODO: Type fixes

import { isFunction } from "#imports";

export function isElement ( element: HTMLElement | ParentNode ) {
  return !!( element && element.nodeType === Node.ELEMENT_NODE );
}

export function getBCR ( element: HTMLElement ) {
  return isElement( element ) ? element.getBoundingClientRect() : null;
}

export function getCS ( element: HTMLElement ) {
  const { getComputedStyle } = window;
  return getComputedStyle && isElement( element ) ? getComputedStyle( element ) : null;
}

export function getStyle ( element: HTMLElement, prop: string ) {
  return prop && isElement( element ) ? element.style[prop] || null : null;
}

export function setStyle ( element: HTMLElement, prop: string, value: string ) {
  if ( prop && isElement( element ) ) {
    element.style[prop] = value;
  }
}

export function contains ( parent: HTMLElement, child: HTMLElement ) {
  return parent && isFunction( parent.contains ) ? parent.contains( child ) : false;
}

export function isVisible ( element: HTMLElement ) {
  if ( !isElement( element ) || !element.parentNode || !contains( document.body, element ) ) {
    return false;
  }

  if ( getStyle( element, "display" ) === "none" ) {
    return false;
  }

  const bcr = getBCR( element );
  return !!( bcr && bcr.height > 0 && bcr.width > 0 );
}

export function getParents ( element: Element | ParentNode, parents: ParentNode[] = [] ): ParentNode[] {
  return element.parentNode === null ? parents : getParents( element.parentNode, parents.concat( [element.parentNode] ) );
}

export function getScrollableParents ( element: HTMLElement ) {
  const scrollableParents = [];

  if ( element ) {
    const parents = getParents( element );
    const overflowRegex = /(auto|scroll)/;

    const overflowCheck = ( node: Element ) => {
      const styleDeclaration = window.getComputedStyle( node, null );

      return overflowRegex.test( styleDeclaration.getPropertyValue( "overflow" ) ) || overflowRegex.test( styleDeclaration.getPropertyValue( "overflowX" ) ) || overflowRegex.test( styleDeclaration.getPropertyValue( "overflowY" ) );
    };

    for ( const parent of parents ) {
      const scrollSelectors = parent.nodeType === 1 && parent.dataset.scrollselectors;

      if ( scrollSelectors ) {
        const selectors = scrollSelectors.split( "," );

        for ( const selector of selectors ) {
          const el = findSingle( parent, selector );

          if ( el && overflowCheck( el ) ) {
            scrollableParents.push( el );
          }
        }
      }

      if ( parent.nodeType !== 9 && overflowCheck( parent ) ) {
        scrollableParents.push( parent );
      }
    }
  }

  return scrollableParents;
}

export function fadeIn ( element: HTMLElement, duration: number ) {
  if ( element ) {
    element.style.opacity = 0;

    let last = +new Date();
    let opacity = 0;

    const tick = function() {
      opacity = +element.style.opacity + ( new Date().getTime() - last ) / duration;
      element.style.opacity = opacity;
      last = +new Date();

      if ( +opacity < 1 ) {
        ( window.requestAnimationFrame && requestAnimationFrame( tick ) ) || setTimeout( tick, 16 );
      }
    };

    tick();
  }
}

export function isTouchDevice () {
  return "ontouchstart" in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
}

export function getWindowScrollTop () {
  const doc = document.documentElement;

  return ( window.pageYOffset || doc.scrollTop ) - ( doc.clientTop || 0 );
}

export function getWindowScrollLeft () {
  const doc = document.documentElement;

  return ( window.pageXOffset || doc.scrollLeft ) - ( doc.clientLeft || 0 );
}

export function getOuterWidth ( el: HTMLElement, margin = false ) {
  if ( el ) {
    let width = el.offsetWidth;

    if ( margin ) {
      const style = getComputedStyle( el );

      width += parseFloat( style.marginLeft ) + parseFloat( style.marginRight );
    }

    return width;
  }

  return 0;
}

export function getOuterHeight ( el: HTMLElement, margin = false ) {
  if ( el ) {
    let height = el.offsetHeight;

    if ( margin ) {
      const style = getComputedStyle( el );

      height += parseFloat( style.marginTop ) + parseFloat( style.marginBottom );
    }

    return height;
  }

  return 0;
}

export function getViewport () {
  const win = window;
  const d = document;
  const e = d.documentElement;
  const g = d.getElementsByTagName( "body" )[0];
  const w = win.innerWidth || e.clientWidth || g.clientWidth;
  const h = win.innerHeight || e.clientHeight || g.clientHeight;

  return { width: w, height: h };
}

export function hasClass ( element: HTMLElement, className: string ) {
  if ( element ) {
    if ( element.classList ) { return element.classList.contains( className ); } else { return new RegExp( "(^| )" + className + "( |$)", "gi" ).test( element.className ); }
  }

  return false;
}

export function findSingle ( element: HTMLElement | ParentNode, selector: string ) {
  return isElement( element ) ? element.querySelector( selector ) : null;
}
